import { toast } from "react-toastify";
import config from "../config";
import bootstrap from "../config/bootstrap";

const init = bootstrap;

const { spaceIOService } = init();

const AuthService = {
	displayMessage: (message, type = "info") => {
		switch (type) {
			case 'success':
				toast.success(message);
				break;
			case 'error':
				toast.error(message);
				break;
			case 'warning':
				toast.warn(message);
				break;
			default:
				toast.info(message);
				break;
		}
	},
	searchAPIModified: async (blessIDAndMacID, type) => {
		try {
			if (blessIDAndMacID.length === 0) {
				AuthService.displayMessage("There are no devices to search. Please check the Excel file.", "error");
				console.error("There are no devices to search. Please check the Excel file.");
				return;
			}
			if (type !== "blessId" && type !== "macId") {
				AuthService.displayMessage("Plese provide valid device data, such as a 'blessId' or 'macId'.", "error");
				console.error("Plese provide valid device data, such as a 'blessId' or 'macId'.");
				return;
			}

			const response = await spaceIOService.request({
				url: `${config.REACT_APP_PRODWS_AFREESPACE_URL}/api/admin/devices/search?type=${type}`,
				init: {
					method: "POST",
					body: JSON.stringify(blessIDAndMacID),
					headers: {
						"Content-Type": "application/json",
					},
				},
			});

			if (!response.ok) {
				const errorText = await response.text();
				AuthService.displayMessage("Couldn't find any device data.", "error");
				console.error(
					`Error fetching data: ${response.status} - ${errorText}`
				);
				return;
			} else if (response.status === 200) {
				const responseData = await response.json();
				return responseData;
			}
		} catch (error) {
			AuthService.displayMessage("Something went wrong. Please contact the administrator.", "error");
			console.error("Error in searchAPIModified:", error);
			return;
		}
	},

	summaryApi: async (macAddress) => {
		try {
			if (!macAddress) {
				console.error("MAC address is required");
				return;
			}

			const response = await spaceIOService.request({
				url: `${config.REACT_APP_NEW_ELECTRIC_LAMBDA_URL}/summary?deviceId=${macAddress}`,
				init: {
					method: "GET",
				},
				bearerToken: true,
			});

			if (!response.ok) {
				const errorText = await response.text();
				console.error(
					`Error fetching summary: ${response.status} - ${errorText}`
				);
				return;
			} else if (response.status === 200) {
				const responseData = await response.json();
				return responseData;
			}
		} catch (error) {
			console.error("Error in summaryApi:", error);
			return;
		}
	},

	productType: async (productId) => {
		try {
			if (!productId) {
				console.error("Product ID is required");
				return;
			}

			const response = await spaceIOService.request({
				url: `${config.REACT_APP_NEW_ELECTRIC_LAMBDA_URL}/productmodel?productId=${productId}`,
				init: {
					method: "GET",
				},
				bearerToken: true,
			});

			if (!response.ok) {
				const errorText = await response.text();
				console.error(
					`Error fetching product type: ${response.status} - ${errorText}`
				);
				return;
			}

			const responseData = await response.json();
			return responseData;
		} catch (error) {
			console.error("Error in productType:", error);
			return;
		}
	},

	modelName: async (deviceId) => {
		try {
			if (!deviceId) {
				console.error("Device ID is required");
				return;
			}

			const response = await spaceIOService.request({
				url: `${config.REACT_APP_NEW_ELECTRIC_LAMBDA_URL}/productdevicegroup?deviceGroupId=${deviceId}`,
				init: {
					method: "GET",
				},
				bearerToken: true,
			});

			if (!response.ok) {
				const errorText = await response.text();
				console.error(
					`Error fetching model name: ${response.status} - ${errorText}`
				);
				return;
			} else if (response.status === 200) {
				const responseData = await response.json();
				return responseData;
			}
		} catch (error) {
			console.error("Error in modelName:", error);
			return;
		}
	},

	deblessedAPI: async (loginKey, macAddress, deviceId) => {
		try {
			if (!loginKey || !macAddress || !deviceId) {
				console.error("Login key, MAC address, and device ID are required");
				return;
			}

			const response = await spaceIOService.request({
				url: `${config.REACT_APP_NEW_ELECTRIC_LAMBDA_URL}/debless?deviceGroupId=${deviceId}`,
				init: {
					method: "DELETE",
					body: JSON.stringify({
						XElectricImpKey: loginKey,
						deviceData: {
							data: [{ type: "device", id: `${macAddress}` }],
						},
					}),
					headers: {
						"Content-Type": "application/json",
					}
				},
				bearerToken: true
			});

			if (!response.ok) {
				const errorText = await response.text();
				console.error(
					`Error deblessing device: ${response.status} - ${errorText}`
				);
				return;
			} else if (response.status === 200) {
				const responseData = await response.json();
				return responseData;
			}
		} catch (error) {
			console.error("Error in deblessedAPI:", error);
			return;
		}
	},

	factoryEvent: async (macAddress, blessId) => {
		try {
			if (!macAddress || !blessId) {
				console.error("MAC address and Bless ID are required");
				return;
			}

			const response = await spaceIOService.request({
				url: `${config.REACT_APP_BLESSING_LAMBDA_URL}/factory_event`,
				init: {
					method: "POST",
					body: JSON.stringify([
						{
							macId: `${macAddress}`,
							blessId: blessId,
						},
					]),
					headers: {
						"Content-Type": "application/json",
					},
				},
				bearerToken: true,
			});

			if (!response.ok) {
				const errorText = await response.text();
				console.error(
					`Error in factoryEvent: ${response.status} - ${errorText}`
				);
				return;
			} else if (response.status === 200) {
				const responseData = await response.json();
				return responseData;
			}
		} catch (error) {
			console.error("Error in factoryEvent:", error);
			return;
		}
	},

	deviceConfig: async (macAddress, blessId) => {
		try {
			if (!macAddress || !blessId) {
				console.error("MAC address and Bless ID are required");
				return;
			}

			const response = await spaceIOService.request({
				url: `${config.REACT_APP_BLESSING_LAMBDA_URL}/device_config`,
				init: {
					method: "POST",
					body: JSON.stringify([
						{
							macId: `${macAddress}`,
							blessId: blessId,
						},
					]),
					headers: {
						"Content-Type": "application/json",
					},
				},
				bearerToken: true,
			});

			if (!response.ok) {
				const errorText = await response.text();
				console.error(
					`Error fetching device config: ${response.status} - ${errorText}`
				);
				return;
			} else if (response.status === 200) {
				const responseData = await response.json();
				return responseData;
			}
		} catch (error) {
			console.error("Error in deviceConfig:", error);
			return;
		}
	},

	toggleDeviceConfigStatus: async (blessIds, status) => {
		try {
			if (!Array.isArray(blessIds) || blessIds.length === 0) {
				AuthService.displayMessage("Something went wrong. Please contact the administrator.", "error");
				console.error("Bless IDs must be a non-empty array");
				return;
			}

			if (typeof status !== "number") {
				AuthService.displayMessage("Something went wrong. Please contact the administrator.", "error");
				console.error("Status must be either 0 or 1");
				return;
			}

			const response = await spaceIOService.request({
				url: `${config.REACT_APP_BLESSING_LAMBDA_URL}/toggle_device_config_status`,
				init: {
					method: "POST",
					body: JSON.stringify({
						bless_ids: blessIds,
						status,
					}),
					headers: {
						"Content-Type": "application/json",
					},
				},
				bearerToken: true,
			});

			if (!response.ok) {
				const errorText = await response.text();
				AuthService.displayMessage("Something went wrong. Please contact the administrator.", "error");
				console.error(
					`Error toggling device config status: ${response.status} - ${errorText}`
				);
				return;
			} else if (response.status === 200) {
				const result = await response.json();
				return result;
			}
		} catch (error) {
			AuthService.displayMessage("Something went wrong. Please contact the administrator.", "error");
			console.error("Error in toggleDeviceConfigStatus:", error);
			return;
		}
	},

	fetchFactoryEvents: async (blessIds) => {
		try {
			if (!Array.isArray(blessIds) || blessIds.length === 0) {
				AuthService.displayMessage("Something went wrong. Please contact the administrator.", "error");
				console.error("Bless IDs must be a non-empty array");
				return;
			}

			const response = await spaceIOService.request({
				url: `${config.REACT_APP_BLESSING_LAMBDA_URL}/fetch_factory_events`,
				init: {
					method: "POST",
					body: JSON.stringify({ bless_ids: blessIds }),
					headers: {
						"Content-Type": "application/json",
					},
				},
				bearerToken: true,
			});

			if (!response.ok) {
				const errorText = await response.text();
				AuthService.displayMessage("Something went wrong. Please contact the administrator.", "error");
				console.error(
					`Error fetching factory events: ${response.status} - ${errorText}`
				);
				return;
			} else if (response.status === 200) {
				const result = await response.json();
				return result;
			}
		} catch (error) {
			AuthService.displayMessage("Something went wrong. Please contact the administrator.", "error");
			console.error("Error in fetchFactoryEvents:", error);
			return;
		}
	},

	fetchItem: async (blessId) => {
		try {
			if (!blessId) {
				AuthService.displayMessage("Something went wrong. Please contact the administrator.", "error");
				console.error("Bless ID is required");
				return;
			}

			const response = await spaceIOService.request({
				url: `${config.REACT_APP_BLESSING_LAMBDA_URL}/fetch/items?blessId=${blessId}`,
				init: {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
					},
				},
				bearerToken: true,
			});
			

			if (!response.ok) {
				const errorText = await response.text();
				AuthService.displayMessage("Something went wrong. Please contact the administrator.", "error");
				console.error(
					`Error fetching item: ${response.status} - ${errorText}`
				);
				return;
			} else if (response.status === 200) {
				const result = await response.json();
				return result;
			}

			return null; // Return null if the response is not OK or not 200

		} catch (error) {
			AuthService.displayMessage("Something went wrong. Please contact the administrator.", "error");
			console.error("Error in fetchItem:", error);
			return;
		}
	},

	storeFactoryEvents: async (data) => {
		try {
			if (
				!data ||
				typeof data !== "object" ||
				!Array.isArray(data) ||
				data.length === 0
			) {
				AuthService.displayMessage("Something went wrong. Please contact the administrator.", "error");
				console.error("Data must be an object with a non-empty array");
				return;
			}

			const response = await spaceIOService.request({
				url: `${config.REACT_APP_BLESSING_LAMBDA_URL}/store_factory_events`,
				init: {
					method: "POST",
					body: JSON.stringify(data),
					headers: {
						"Content-Type": "application/json",
					},
				},
				bearerToken: true,
			});

			if (!response.ok) {
				const errorText = await response.text();
				console.error(
					`Error storing factory events: ${response.status} - ${errorText}`
				);
				return;
			} else if (response.status === 200) {
				const result = await response.json();
				return result;
			}
		} catch (error) {
			console.error("Error in storeFactoryEvents:", error);
			return;
		}
	},

	migrateDeviceconfig: async (data) => {
		try {
			if (
				!data ||
				typeof data !== "object"
			) {
				console.error(
					"Data must be an object with a non-empty array of events"
				);
				return;
			}

			const response = await spaceIOService.request({
				url: `${config.REACT_APP_BLESSING_LAMBDA_URL}/dsm/deviceconfig`,
				init: {
					method: "POST",
					body: JSON.stringify(data),
					headers: {
						"Content-Type": "application/json",
					},
				},
				bearerToken: true,
			});

			if (!response.ok) {
				const errorText = await response.text();
				console.error(`Error in deviceconfig: ${response.status} - ${errorText}`);
				return;
			} else if (response.status === 200) {
				const result = await response.json();
				return result;
			}
		} catch (error) {
			console.error("Error in deviceconfig:", error);
			return;
		}
	},

	fetchProductType: async (field, productType) => {
		try {
			if (field !== "product_type" && field !== "product_type_id") {
				console.error("Field must be either 'product_type' or 'product_type_id'");
				return;
			}
			if (!productType) {
				console.error("Product type name or ID is required");
				return;
			}


			const response = await spaceIOService.request({
				url: `${config.REACT_APP_BLESSING_LAMBDA_URL}/fetch_product_type?${field}=${productType}`,
				init: {
					method: "GET",
				},
				bearerToken: true,
			});

			if (!response.ok) {
				const errorText = await response.text();
				console.error(
					`Error fetching product type: ${response.status} - ${errorText}`
				);
				return;
			} else if (response.status === 200) {
				const result = await response.json();
				return result;
			}
		} catch (error) {
			console.error("Error in fetchProductType:", error);
			return;
		}
	},

	items: async (hardwareDeviceId, data) => {
		try {
			if (!hardwareDeviceId || !data || typeof data !== "object") {
				console.error(
					"Hardware device ID and data must be provided and data must be an object"
				);
				return;
			}

			const response = await spaceIOService.request({
				url: `${config.REACT_APP_BLESSING_LAMBDA_URL}/items?item_mac=${hardwareDeviceId}`,
				init: {
					method: "POST",
					body: JSON.stringify(data),
					headers: {
						"Content-Type": "application/json",
						"x-api-key": config.REACT_APP_FACTORY_KEY,
					},
				},
				bearerToken: true,
			});

			if (!response.ok) {
				const errorText = await response.text();
				console.error(`Error in items: ${response.status} - ${errorText}`);
				return;
			} else if (response.status === 200) {
				const result = await response.json();
				return result;
			}
		} catch (error) {
			console.error("Error in items:", error);
			return;
		}
	},
};
export default AuthService;
